export default "__VITE_ASSET__B0TdN4Qk__"